export default "__VITE_ASSET__DGfLrJPM__"